export const LOAD_LATEST_PRESENTATIONS = 'LOAD_LATEST_PRESENTATIONS';
export const LOAD_LATEST_PRESENTATIONS_SUCCESS = 'LOAD_LATEST_PRESENTATIONS_SUCCESS';
export const LOAD_LATEST_PRESENTATIONS_ERROR = 'LOAD_LATEST_PRESENTATIONS_ERROR';
